import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import NotSentActionsCellRenderer from '../components/NotSentActionsCellRenderer';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';
import { useCommonKpiColDefs } from './useCommonKpiColDefs';

export default function useKPIRequestsNotSentColDefs() {
  const {
    respondentColDef,
    templateColDef,
    frequencyColDef,
    periodColDef,
    fyeColDef,
    commonCompanyDefs,
    granularityColDef,
    secondaryRespondentColDef,
  } = useCommonKpiColDefs();
  const columnDefs: ColDef<IKPIRequestDataModel>[] = useMemo(() => {
    const res = [
      commonCompanyDefs,
      templateColDef,
      frequencyColDef,
      fyeColDef,
      periodColDef,
      respondentColDef,
      secondaryRespondentColDef,
      {
        minWidth: 130,
        maxWidth: 130,
        cellStyle: { paddingLeft: 10, paddingRight: 10 },
        pinned: 'right',
        sortable: false,
        resizable: false,
        cellRenderer: NotSentActionsCellRenderer,
      },
    ] as ColDef<IKPIRequestDataModel>[];

    res.splice(3, 0, granularityColDef as unknown as ColDef<IKPIRequestDataModel>);

    return res;
  }, [
    commonCompanyDefs,
    frequencyColDef,
    fyeColDef,
    granularityColDef,
    periodColDef,
    respondentColDef,
    secondaryRespondentColDef,
    templateColDef,
  ]);

  const defaultColDef = useMemo<ColDef>(
    () => ({
      flex: 1,
      minWidth: 120,
      resizable: true,
      sortable: true,
      filter: false,
      suppressHeaderMenuButton: true,
      suppressMovable: true,
      getQuickFilterText: () => {
        return '';
      },
    }),
    []
  );

  return {
    columnDefs,
    defaultColDef,
  };
}
